import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
export default {
  namespaced: true,
  state() {
    return {
      ratios: [],
      result: [],
      allRatios: [],
      ratioDetails: [],
      allDealerProfit: [],
      totalAllDealerProfit: 0,
      totalRatio: 0,
      totalRatioResult: 0,
      payments: [],
      total: 0,
      totalBonus: 0,
      totalBonusResult: 0,
      totalProtaction: 0,
      totalProtactionResult: 0,
      finalRatio: 0,
      finalRatioResult: 0,
      totalDiscount: 0,
      totalDiscountResult: 0,
      countOrderReturn: 0,
      countOrderReturnResult: 0,
      countOrderDone: 0,
      countOrderDoneResult: 0,
      totalProfit: 0,
      countOrderReturnDealer: 0,
      countOrderDoneDealer: 0,
      ratioLoaded: false,
      postReceipt: false,
      deleteing: false,
      PostreturnRatio: false,
      ratioDetailsLoaded: false,
      postRtio: false,
    };
  },
  mutations,
  getters,
  actions,
};
